import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { globalSliderConfig } from '../../utils/sliderConfig';
/**
 * Slider class to handle the creation and management of Splide sliders.
 * This class allows for creating sliders with a default configuration or with custom options.
 */
export class Slider {
    static key(selector) {
        return selector.startsWith('#') ? selector : `#${selector}`;
    }
    static goTo(selector, index) {
        const key = Slider.key(selector);
        const splide = Slider.splides[key];
        if (!splide)
            return;
        splide.go(index);
        splide.refresh();
    }
    static createOnce(selector, config, isCard) {
        const key = Slider.key(selector);
        const mergedConfig = {
            ...globalSliderConfig,
            ...config,
            classes: {
                ...globalSliderConfig.classes,
                arrow: isCard
                    ? 'splide__arrow splide__arrow--blue'
                    : 'splide__arrow splide__arrow--green',
            },
        };
        if (Slider.splides[key]) {
            Slider.splides[key].destroy(true);
            delete Slider.splides[key];
        }
        const splide = new Splide(key, mergedConfig);
        const updateCardArrows = () => {
            var _a;
            if (!isCard)
                return;
            const root = document.querySelector(key);
            const prev = root === null || root === void 0 ? void 0 : root.querySelector('.splide__arrow--prev');
            const next = root === null || root === void 0 ? void 0 : root.querySelector('.splide__arrow--next');
            const totalSlides = (_a = root === null || root === void 0 ? void 0 : root.querySelectorAll('.splide__slide').length) !== null && _a !== void 0 ? _a : 0;
            const lastIndex = totalSlides - 1;
            if (!prev || !next)
                return;
            prev.disabled = splide.index <= 0;
            next.disabled = splide.index >= lastIndex;
        };
        splide.on('mounted moved updated refreshed resized', () => {
            requestAnimationFrame(updateCardArrows);
        });
        requestAnimationFrame(() => {
            if (mergedConfig.autoScroll) {
                splide.mount({ AutoScroll });
            }
            else {
                splide.mount();
            }
        });
        Slider.splides[key] = splide;
    }
    static recreate(selector, config, isCard = true) {
        const key = Slider.key(selector);
        globalSliderConfig.classes.arrow = 'splide__arrow splide__arrow--green';
        if (Slider.splides[key]) {
            Slider.splides[key].destroy(true);
            delete Slider.splides[key];
        }
        const splide = new Splide(key, { ...globalSliderConfig, ...config });
        splide.mount();
        Slider.splides[key] = splide;
    }
    static destroy(selector) {
        const key = Slider.key(selector);
        if (!Slider.splides[key])
            return;
        Slider.splides[key].destroy(true);
        delete Slider.splides[key];
    }
    static createSynced(mainSelector, thumbsSelector, mainConfig, thumbsConfig) {
        const mainKey = Slider.key(mainSelector);
        const thumbsKey = Slider.key(thumbsSelector);
        if (Slider.splides[mainKey]) {
            Slider.splides[mainKey].destroy(true);
            delete Slider.splides[mainKey];
        }
        if (Slider.splides[thumbsKey]) {
            Slider.splides[thumbsKey].destroy(true);
            delete Slider.splides[thumbsKey];
        }
        const main = new Splide(mainKey, {
            ...globalSliderConfig,
            ...mainConfig,
        });
        const thumbs = new Splide(thumbsKey, {
            ...globalSliderConfig,
            ...thumbsConfig,
        });
        main.sync(thumbs);
        main.mount();
        thumbs.mount();
        Slider.splides[mainKey] = main;
        Slider.splides[thumbsKey] = thumbs;
    }
}
Slider.splides = {};
